import { useMutation, useQueryClient } from 'react-query'
import { useSelector } from 'react-redux'
import callAPI from '../../API/callSecureAPI'
import endpoints from '../../API/endpoints'
import { useAuth0 } from '../../contexts/auth0-context'

export type ExternalActivitySource = 'GSL' | 'Planisware'

export type ImportExternalActivityInput = {
    studyNumber: string
    source: ExternalActivitySource
    title: string
    organizationId: string
    description?: string
    status?: string
    startDate?: string
    endDate?: string
    plannedStartDate?: string
    plannedEndDate?: string
    category?: string
    function?: string
    therapeuticArea?: string
    compoundName?: string[]
    genericName?: string[]
    indication?: string
    affiliateName?: string
    providerName?: string
    sponsorType?: string
    countries?: string[]
    studyReportDate?: string
    terminationDate?: string
    studyOwner?: string
    titleLong?: string
    vendorDetails?: string
    vendor?: boolean
    type?: string
    population?: string
    externalId?: string
}

type ImportExternalActivitiesVariables = {
    activities: ImportExternalActivityInput[]
    roadmapId: string
}

type ImportExternalActivityResult = {
    studyNumber: string
    success: boolean
    reason?: string
    overwritten?: boolean
}

export const useImportExternalActivityMutation = () => {
    const { getTokenSilently } = useAuth0()
    const queryClient = useQueryClient()

    // @ts-expect-error store is not typed properly
    const strategyId = useSelector((state) => state.strategy?._id)

    const importExternalActivities = async ({
        activities,
        roadmapId,
    }: ImportExternalActivitiesVariables): Promise<ImportExternalActivityResult[]> => {
        const token = await getTokenSilently({ audience: 'https://atlas.aesara.com' })

        const { url, method } = endpoints.importExternalActivity

        const response = await callAPI(`${url}${roadmapId}/external-import`, method, token, { activities })

        if (!response.success) {
            throw new Error(response.error ?? 'Failed to import external activities')
        }

        return response.data
    }

    return useMutation(importExternalActivities, {
        onSuccess: () => {
            queryClient.invalidateQueries(['activities', strategyId])
        },
    })
}
